import {CANVAS_IMAGES_LOAD_REQUEST, CANVAS_IMAGES_LOAD_SUCCESS, CANVAS_TRANSFORMATION_CHANGE} from '../actions/EditorCanvasActions';
import {SWITCH_IMAGE_SUCCESS, SWITCH_IMAGE_REQUEST, CLOSE_IMAGE} from '../actions/ImageActions';
import {Transformation} from 'rc-canvas/lib/Transformation';

const initialTransformation = new Transformation();

const initState = {
    imagesRecord: null,
    transformation: initialTransformation
};

export function editorCanvas(state = initState, action) {
    switch (action.type) {
        case CLOSE_IMAGE:
        case SWITCH_IMAGE_REQUEST: {
            return {...state, imagesRecord: null};
        }
        case CANVAS_IMAGES_LOAD_REQUEST: {
            return {...state, loading: true};
        }
        case CANVAS_TRANSFORMATION_CHANGE: {
            return {...state, transformation: action.transformation};
        }
        case SWITCH_IMAGE_SUCCESS: {
            return {...state, transformation: initialTransformation};
        }
        case CANVAS_IMAGES_LOAD_SUCCESS:
            return {...state, loading: false, imagesRecord: action.imagesRecord};
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/editorCanvas.js